var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.75 11V4C22.75 3.271 22.46 2.571 21.945 2.055C21.429 1.54 20.729 1.25 20 1.25C16.168 1.25 7.832 1.25 4 1.25C3.271 1.25 2.571 1.54 2.055 2.055C1.54 2.571 1.25 3.271 1.25 4V20C1.25 20.729 1.54 21.429 2.055 21.945C2.571 22.46 3.271 22.75 4 22.75H11C11.414 22.75 11.75 22.414 11.75 22C11.75 21.586 11.414 21.25 11 21.25C11 21.25 6.652 21.25 4 21.25C3.668 21.25 3.351 21.118 3.116 20.884C2.882 20.649 2.75 20.332 2.75 20V4C2.75 3.668 2.882 3.351 3.116 3.116C3.351 2.882 3.668 2.75 4 2.75H20C20.332 2.75 20.649 2.882 20.884 3.116C21.118 3.351 21.25 3.668 21.25 4V11C21.25 11.414 21.586 11.75 22 11.75C22.414 11.75 22.75 11.414 22.75 11Z",
    fill: "#1D2939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7.75H22C22.414 7.75 22.75 7.414 22.75 7C22.75 6.586 22.414 6.25 22 6.25H2C1.586 6.25 1.25 6.586 1.25 7C1.25 7.414 1.586 7.75 2 7.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 5.25H5.5C5.914 5.25 6.25 4.914 6.25 4.5C6.25 4.086 5.914 3.75 5.5 3.75H4.5C4.086 3.75 3.75 4.086 3.75 4.5C3.75 4.914 4.086 5.25 4.5 5.25Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 5.25H9C9.414 5.25 9.75 4.914 9.75 4.5C9.75 4.086 9.414 3.75 9 3.75H8C7.586 3.75 7.25 4.086 7.25 4.5C7.25 4.914 7.586 5.25 8 5.25Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 5.25H12.5C12.914 5.25 13.25 4.914 13.25 4.5C13.25 4.086 12.914 3.75 12.5 3.75H11.5C11.086 3.75 10.75 4.086 10.75 4.5C10.75 4.914 11.086 5.25 11.5 5.25Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 13.25C14.93 13.25 13.25 14.93 13.25 17C13.25 19.07 14.93 20.75 17 20.75C19.07 20.75 20.75 19.07 20.75 17C20.75 14.93 19.07 13.25 17 13.25ZM17 14.75C18.242 14.75 19.25 15.758 19.25 17C19.25 18.242 18.242 19.25 17 19.25C15.758 19.25 14.75 18.242 14.75 17C14.75 15.758 15.758 14.75 17 14.75Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 17.75H22C22.414 17.75 22.75 17.414 22.75 17C22.75 16.586 22.414 16.25 22 16.25H20C19.586 16.25 19.25 16.586 19.25 17C19.25 17.414 19.586 17.75 20 17.75Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.652 15.409L21.066 13.995C21.359 13.702 21.359 13.227 21.066 12.934C20.773 12.641 20.298 12.641 20.005 12.934L18.591 14.348C18.298 14.641 18.298 15.116 18.591 15.409C18.884 15.702 19.359 15.702 19.652 15.409Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.75 14V12C17.75 11.586 17.414 11.25 17 11.25C16.586 11.25 16.25 11.586 16.25 12V14C16.25 14.414 16.586 14.75 17 14.75C17.414 14.75 17.75 14.414 17.75 14Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.409 14.348L13.995 12.934C13.702 12.641 13.227 12.641 12.934 12.934C12.641 13.227 12.641 13.702 12.934 13.995L14.348 15.409C14.641 15.702 15.116 15.702 15.409 15.409C15.702 15.116 15.702 14.641 15.409 14.348Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 16.25H12C11.586 16.25 11.25 16.586 11.25 17C11.25 17.414 11.586 17.75 12 17.75H14C14.414 17.75 14.75 17.414 14.75 17C14.75 16.586 14.414 16.25 14 16.25Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.348 18.591L12.934 20.005C12.641 20.298 12.641 20.773 12.934 21.066C13.227 21.359 13.702 21.359 13.995 21.066L15.409 19.652C15.702 19.359 15.702 18.884 15.409 18.591C15.116 18.298 14.641 18.298 14.348 18.591Z",
    fill: "currentColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.25 20V22C16.25 22.414 16.586 22.75 17 22.75C17.414 22.75 17.75 22.414 17.75 22V20C17.75 19.586 17.414 19.25 17 19.25C16.586 19.25 16.25 19.586 16.25 20Z",
    fill: "currentColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.591 19.652L20.005 21.066C20.298 21.359 20.773 21.359 21.066 21.066C21.359 20.773 21.359 20.298 21.066 20.005L19.652 18.591C19.359 18.298 18.884 18.298 18.591 18.591C18.298 18.884 18.298 19.359 18.591 19.652Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCms);
export default __webpack_public_path__ + "static/media/cms.64d20baf7ba7415a5a3752b36e19b018.svg";
export { ForwardRef as ReactComponent };